import { create } from 'zustand';

type UseBookingModals = {
  visibleBookingModal: boolean;
  modalBookingId: number | 'all' | null;
  setVisibleBookingModal: (value: boolean, id?: number | 'all') => void;
};

export const useBookingModals = create<UseBookingModals>()(set => ({
  visibleBookingModal: false,
  modalBookingId: null,
  setVisibleBookingModal: (value: boolean, id?: number | 'all') => {
    set({ visibleBookingModal: value, modalBookingId: id ?? null });
  },
}));
